export default __webpack_public_path__ + "static/notification-7c969544084a834a25aab5bed1ed1066.png";